"use client";

import { PRIVACY_POLICY_URL } from "@/lib/cookie-consent";
import { CookieSettingsLink } from "@/lib/marketing-analytics/cookie-settings-link";
import { BRAND_NAME } from "@/lib/marketing-seo";
import { BrandLogoMark } from "@v1/ui/brand-logo-mark";
import { useTranslations } from "next-intl";
import Link from "next/link";
import type { ReactElement } from "react";
import { DevelopersFunnelSocial } from "../developers/_components/developers-funnel-social";
import { CAREERS_CONTENT } from "./careers-content";
import { useCareersLanguage } from "./careers-language-context";

/** Slim dark footer, identical to the developers funnel footer. */
export function CareersFooter(): ReactElement {
  const tI18n = useTranslations("public.careersFooter");
  const { lang } = useCareersLanguage();
  const t = CAREERS_CONTENT[lang].footer;

  return (
    <footer className="dvf-footer">
      <div className="dvf-footer-inner">
        <span className="dvf-footer-brand">
          <BrandLogoMark width={20} height={20} variant="website" />
          {BRAND_NAME}
        </span>
        <div className="dvf-footer-links">
          <DevelopersFunnelSocial youtubeLabel={t.youtube} />
          <span className="dvf-footer-legal">
            <Link href="/impressum">{t.imprint}</Link>
            <Link href={PRIVACY_POLICY_URL}>{t.privacy}</Link>
            <CookieSettingsLink variant="careers" />
          </span>
        </div>
      </div>
    </footer>
  );
}
